import { useState, useEffect } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import { checkForRating, editRating, postRating } from '../apiCalls'


const RateActionComp = (props) => {
    //Set constant variables
    const idea = props.mods.idea
    const updateAverage = props.mods.updateAverage

    //Set State
    const [myRating, setMyRating] = useState({})
    const [ratingExists, setRatingExists] = useState(false)

    useEffect(() => {
        initialRate(idea._id)
    })

    const initialRate = async (ideaId) => {
        let result = await checkForRating(ideaId)
        if (result) {
            setRatingExists(true)
            setMyRating(result)
        }
    }

    const updateRating = async (ideaId, ratingId, score) => {
        const object = {score: score}
        await editRating(ratingId, object)
        updateAverage(ideaId)
    }

    const newRating = async (ideaId, score) => {
        const object = {score: score, idea: idea}
        await postRating(object)
        updateAverage(ideaId)
    }

    const handleSelect = (score) => {
        if (ratingExists) {
            updateRating(idea._id, myRating._id, score)
        } else {
            newRating(idea._id, score)
        }
    }

    return (
        <>
            <Dropdown>
                <p>My Rating: {ratingExists ? myRating.score + " / 5" : "-- / 5"} <Dropdown.Toggle size="sm" variant="dark" id="dropdown-basic" className="ratingDropdown defaultButton">
                </Dropdown.Toggle></p>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={(e) => {
                        handleSelect(1)
                    }}>1</Dropdown.Item>
                    <Dropdown.Item onClick={(e) => {
                        handleSelect(2)
                    }}>2</Dropdown.Item>
                    <Dropdown.Item onClick={(e) => {
                        handleSelect(3)
                    }}>3</Dropdown.Item>
                    <Dropdown.Item onClick={(e) => {
                        handleSelect(4)
                    }}>4</Dropdown.Item>
                    <Dropdown.Item onClick={(e) => {
                        handleSelect(5)
                    }}>5</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
}

export default RateActionComp